<template>
  <div class="footer">
    <div class="footer__header flex mw9 center">
      <div class="footer__item footer__item--first">
        <p class="ma0">{{$t('cTA')}}</p>
      </div>

      <div class="footer__item footer__item--second">
        <button class="footer__item__link" @click="showPhoneModal">
          <svg
            class="icon"
            width="30px"
            height="25px"
            viewBox="0 0 40 40"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>Phone Icon</title>
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(3.000000, 3.000000)" stroke="#000000" stroke-width="2">
                <path
                  d="M5.13245033,3 C8.08874172,4.51734752 11.784106,9.82806386 11.784106,9.82806386 C8.08874172,12.1040851 7.34966887,14.3801064 9.56688742,16.6561277 L17.6966887,25.0015391 C19.1748344,26.5188866 21.392053,25.0015391 23.6092715,21.2081703 C29.5218543,24.2428653 31,29.5535817 31,29.5535817 C24.3483444,38.6576668 18.4357616,34.1056242 15.4794702,31.829603 C12.5231788,29.5535817 3.21529536,19.5481921 0.698013245,14.3801064 C-2.25827815,8.31071633 5.13245033,3 5.13245033,3 Z"
                ></path>
                <path d="M16,7 C22.4285714,8.53846154 25.2857143,13.1538462 26,17" id="Stroke-3"></path>
                <path d="M18,0 C28.2857143,2.30769231 32.8571429,9.23076923 34,15" id="Stroke-5"></path>
              </g>
            </g>
          </svg>
          <h4 class="text">{{$t('callUs')}}</h4>
        </button>

        <transition name="fade">
          <div
            v-if="isOpen"
            class="footer__item__modal"
            @mouseover="isHovering"
            @mouseleave="notHovering"
            v-on:blur="inputBlur"
          >
            <div class="mb5">
              <a class="link db" :href="`tel:${usCanadaNumber}`">
                <h2 class="title mt0 fw4">1-{{usCanadaNumber}}</h2>
                <p class="text ttu fw3 f6 mb3">({{$t('usCanTollFreeText')}})</p>
              </a>
            </div>
            <div>
              <a class="link db" :href="`tel:${internationalNumber}`">
                <h2 class="title fw4">1-{{internationalNumber}}</h2>
                <p class="text ttu fw3 f6 mb1">({{$t('internationalPhoneNumberText')}})</p>
              </a>
            </div>
          </div>
        </transition>
      </div>

      <div class="footer__item footer__item--third">
        <router-link class="footer__item__link flex" :to="{name: 'requests'}">
          <svg
            class="icon"
            width="30px"
            height="25px"
            viewBox="0 0 40 40"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>Mail Icon</title>
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(0.000000, 5.000000)" stroke="#000000" stroke-width="2">
                <g transform="translate(1.000000, 0.000000)">
                  <polyline
                    points="3.75 11.4148488 3.75 0.000360465116 36 0.000360465116 36 31.0003605 3.75 31.0003605 3.75 27.3957093"
                  ></polyline>
                  <polyline points="36 4.61813488 19.875 20.1181349 3.75 4.61813488"></polyline>
                  <path d="M1.5,20.9069767 L7.5,20.9069767"></path>
                  <path d="M0,24.5116279 L6,24.5116279"></path>
                </g>
                <path d="M10,17.5 L8,17.5"></path>
                <path d="M10,24.5 L8,24.5"></path>
                <path d="M7,17.5 L0,17.5"></path>
                <path d="M7,13.5 L5,13.5"></path>
                <path d="M4,13.5 L2,13.5"></path>
              </g>
            </g>
          </svg>
          <h4
            class="text"
            @click="trackPageClick(`submit_request_link`)"
          >{{$t('submitRequestTitle')}}</h4>
        </router-link>
      </div>
    </div>

    <div class="footer__body">
      <div class="footer__body__inner center mb3">
        <div
          v-html="$t('footerText', {siteName: siteName, termsLink: termsLink, privacyLink: privacyLink})"
          class="text mw7-l mt2 footer-text"
        ></div>
      </div>
      <div class="mb4 mb5-l ph4">
        <div class="flex-l justify-between white row-container">
          <div>
            <ul class="list flex pa0 flex justify-center mt4 mt0-l mb0-l">
              <li>
                <router-link class="link" :to="{name: 'home'}">{{$t('support')}}</router-link>
              </li>
              <li>
                <a class="link" :href="aboutLink">{{$t('aboutLink')}}</a>
              </li>
              <li>
                <router-link class="link" :to="{name: 'requests'}">{{$t('contact')}}</router-link>
              </li>
              <li>
                <a class="link" :href="loginLink">{{$t('loginLinkText')}}</a>
              </li>
            </ul>
          </div>
          <div>
            <p v-html="$t('footerCopyright', { siteName: capitalizeSitename, currentYear: currentYear } )" class="text fw6 f6 tc"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { trackPageClick } from '@/utils/common';
export default {
  data() {
    return {
      phoneModalVisible: false,
      isOpen: false,
      hovering: false
    };
  },
  computed: {
    siteName() {
      return this.$store.state.siteDetails.site_name;
    },
    aboutLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/about-us`;
    },
    contactLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/contact`;
    },
    loginLink() {
      return `https://members.${this.$store.state.siteDetails.domain_name}/login`;
    },
    termsLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/terms`;
    },
    privacyLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/privacy`;
    },
    internationalNumber() {
      return this.$store.state.siteDetails.support_number_intl;
    },
    usCanadaNumber() {
      return this.$store.state.siteDetails.support_number_us_canada;
    },
		currentYear() {
			return new Date().getFullYear();
		}
  },
  methods: {
    trackPageClick,
    showPhoneModal() {
      this.isOpen = !this.isOpen;
    },
    inputBlur() {
      console.log('Blue');
      if (!this.hovering) {
        this.isOpen = false;
      }
    },
    isHovering() {
      this.hovering = true;
    },
    notHovering() {
      this.hovering = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.footer {
  background: #ddd;
  border-color: #b4b4b4;
  border-width: 1px 0;
  border-style: solid;
  margin-top: 2rem;
}

.footer__header {
  padding: 0% 10% 0% 10%;
  height: 80px;
  margin: 0 auto;
}
.footer__item {
  text-align: center;
  margin: 0;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer__item--first {
  display: none;
  flex: 1;
}
.footer__item--second {
  position: relative;
}
.footer__item--third {
  flex: 1;
}

.footer__item__link {
  color: $theme-highlight;
  font-weight: 600;
  text-transform: uppercase;
  justify-content: center;
  align-items: center;
  display: flex;
  text-decoration: none;
  width: 100%;
  -webkit-appearance: none;
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;

  .text {
    font-weight: 600;
  }

  .icon {
    margin-right: 0.5em;

    polyline,
    path {
      stroke: $theme-highlight;
    }
  }
  .text {
    margin: 0;
  }
}

.footer__body {
  background: #2a2a2a;
  padding: 1.5rem 0;
  line-height: 1.5rem;

  .list {
    font-size: 0.85rem;
    li {
      margin-right: 1.5rem;
      .link {
        color: #fff;
        font-weight: 600;
      }
    }
  }
}
.footer__body__inner {
  max-width: 50rem;

  .text {
    font-size: 0.9em;
    color: #676767;
  }
  .link {
    color: $theme-highlight;
    text-decoration: underline;
  }
}
.footer__item__modal {
  position: absolute;
  background: #fff;
  padding: 1rem;
  width: 320px;
  border: 1px solid #000;
  border-radius: 6px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 100%;

  .link {
    color: $theme-highlight;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media (min-width: 641px) {
  .footer__header {
    // padding: 0 2.5rem;
    padding: 0% 10% 0% 10%;
    max-width: none;

    .footer__item {
      padding: 0 0.5rem;
    }
  }
  .footer__item--first {
    display: flex;
  }
}
</style>
